module.exports = __webpack_public_path__ + "img/smartby_favicon_dark.0d140480.png";